<template>
  <div class="photo-list">
    <template v-if="loading">
      <div
        v-for="n in 10"
        :key="'skeleton-' + n"
        class="card shadow-sm mb-3 p-3 d-flex flex-row justify-content-between align-items-center"
      >
        <div class="row w-100 align-items-start gx-3 gy-2">
          <div class="col-auto d-none d-md-block">
            <div class="placeholder-glow">
              <div
                class="placeholder rounded w-100"
                style="height: 100px; width: 100px"
              ></div>
            </div>
          </div>
          <div class="col-9 col-md-10">
            <div class="placeholder-glow">
              <div class="placeholder col-6 mb-2"></div>
              <div class="placeholder col-12 mb-1"></div>
              <div class="placeholder col-8 mb-1"></div>
              <div class="d-flex gap-2 mt-3">
                <span
                  class="placeholder btn btn-secondary disabled col-3 d-md-none"
                ></span>
                <span class="placeholder btn btn-danger disabled col-3"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div
        v-for="photo in photos"
        :key="photo.id"
        class="card shadow-sm mb-3 p-3 d-flex flex-row justify-content-between align-items-center"
      >
        <div class="row w-100 align-items-start gx-3 gy-2">
          <div
            class="col-auto d-none d-md-block"
            style="height: 100px; width: 100px; position: relative"
          >
            <div
              v-if="!loadedImages[photo.id]"
              class="placeholder-glow position-absolute top-0 start-0 w-100 h-100"
            >
              <div class="placeholder rounded w-100 h-100"></div>
            </div>
            <img
              :src="photo.s3_url"
              alt="Preview"
              class="rounded w-100 h-100"
              style="object-fit: cover"
              loading="lazy"
              @load="onImageLoad(photo.id)"
              @click="$emit('photo-click', photo)"
            />
          </div>

          <div class="col-9 col-md-10">
            <div class="fw-bold">#{{ photo.id }} {{ photo.unic_id }} 
              <span
                class="badge ms-2 rounded-pill"
                :class="getCoinTypeBadgeClass(photo.coin_type)"
              >
                {{ photo.coin_type_label }}
              </span>
            </div>
            <div class="text-muted">
              Price: {{ photo.price / 10 }} GEL | Device:
              {{ photo.device_id }} {{ photo.device.name ?? '' }} | Print: {{ photo.print_count }}x |
              {{ photo.colored ? "Colored" : "B/W" }} | Test:
              {{ photo.is_test ? "Yes" : "No" }} <br />
              Print: {{ photo.print_time }} | Upload:
              {{ photo.s3_upload_date }}
            </div>
            <div class="btn-group mt-3">
              <button
                class="btn btn-outline-secondary btn-sm me-2 d-md-none"
                title="View"
                @click="$emit('photo-click', photo)"
              >
                <i class="bi bi-eye"></i> View
              </button>
              <button
                class="btn btn-outline-danger btn-sm"
                title="Delete"
                @click="$emit('photo-delete', photo)"
              >
                <i class="bi bi-trash"></i> Delete
              </button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
  
<script>
export default {
  name: "PhotoList",
  props: {
    photos: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loadedImages: {},
    };
  },
  watch: {
    photos: {
      immediate: true,
      handler() {
        this.loadedImages = {};
      },
    },
  },
  methods: {
    onImageLoad(id) {
      this.loadedImages[id] = true;
    },
    getCoinTypeBadgeClass(coinType) {
      switch (coinType) {
        case 'coin_1':
          return 'bg-coin';
        case 'coin_2':
          return 'bg-cash';
        case 'coin_3':
          return 'bg-card';
        default:
          return 'bg-unknown';
      }
    }
  },
};
</script>